var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { Fragment, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { useUrlProps } from '../../common/urlProps';
import useDebouncedEffect from '../../common/useDebouncedEffect';
import useFetch from '../../common/useFetch';
import gs from '../../styles/style';
var FontAwesomeIcon = require('@fortawesome/react-fontawesome').FontAwesomeIcon;
var DataframeManager = (function () {
    function DataframeManager(state, setState) {
        var _this = this;
        this.getName = function () {
            return _this.state.name;
        };
        this.getData = function () {
            return _this.state.data;
        };
        this.loadData = function (data) {
            _this.setState(function (state) {
                return __assign(__assign({}, state), { loading: false, data: _this.isPaginated() ? data.data : data, page: _this.isPaginated() ? data.current_page : null, total: _this.isPaginated() ? data.total : data.length });
            });
        };
        this.reload = function () {
            _this.setState(function (state) {
                return __assign(__assign({}, state), { loads: state.loads + 1 });
            });
        };
        this.getParams = function () {
            return {
                page: _this.state.page,
                perPage: _this.state.perPage,
                search: _this.state.search,
                loads: _this.state.loads
            };
        };
        this.getPage = function () {
            return _this.state.page;
        };
        this.setPage = function (page) {
            _this.setState(function (state) {
                return __assign(__assign({}, state), { page: page });
            });
        };
        this.getPerPage = function () {
            return _this.state.perPage;
        };
        this.getPageCount = function () {
            if (_this.state.perPage) {
                return Math.ceil(_this.state.total / _this.state.perPage);
            }
            return null;
        };
        this.isPaginated = function () {
            return !!_this.state.perPage;
        };
        this.getFrom = function () {
            return _this.state.from;
        };
        this.getTo = function () {
            return _this.state.to;
        };
        this.search = function (search) {
            _this.setState(function (state) {
                return __assign(__assign({}, state), { search: search });
            });
        };
        this.getSearch = function () {
            return _this.state.search;
        };
        this.isLoading = function () {
            return _this.state.loading;
        };
        this.getKey = function () {
            return JSON.stringify(_this.getParams());
        };
        this.state = state;
        this.setState = setState;
    }
    return DataframeManager;
}());
function useDataframe(fetch, _a) {
    var _b = _a.page, page = _b === void 0 ? 1 : _b, _c = _a.perPage, perPage = _c === void 0 ? null : _c, _d = _a.search, search = _d === void 0 ? null : _d, _e = _a.name, name = _e === void 0 ? null : _e;
    var urlProps = useUrlProps(name);
    var _f = useState({
        name: name,
        data: [],
        page: perPage ? parseInt(urlProps.get('page'), 10) || page : null,
        perPage: perPage || null,
        from: 0,
        to: 0,
        total: 0,
        search: urlProps.get('search') || search,
        loading: true,
        loads: 0
    }), state = _f[0], setState = _f[1];
    var dataframe = new DataframeManager(state, setState);
    var fetchData = useFetch(fetch, {
        onSuccess: dataframe.loadData
    }).get;
    useEffect(function () {
        setState(function (state) {
            return __assign(__assign({}, state), { loading: true, loads: state.loads });
        });
        fetchData({ params: dataframe.getParams() });
    }, Object.values(dataframe.getParams()));
    return dataframe;
}
;
var Pager = function (_a) {
    var dataframe = _a.dataframe, _b = _a.maxLength, maxLength = _b === void 0 ? 7 : _b, props = __rest(_a, ["dataframe", "maxLength"]);
    var t = useTranslation()[0];
    var _c = useState(dataframe.getPage()), page = _c[0], setPage = _c[1];
    var urlProps = useUrlProps(dataframe.getName());
    useEffect(function () {
        if (page && page > 1) {
            urlProps.push({ page: page });
        }
    }, []);
    useEffect(function () {
        dataframe.setPage(page);
        var pageInUrl = parseInt(urlProps.get('page'), 10);
        if (page == 1) {
            if (pageInUrl) {
                urlProps.push({ page: null });
            }
        }
        else if (pageInUrl != page) {
            ;
            urlProps.push({ page: page });
        }
    }, [page]);
    useEffect(function () {
        var pageInUrl = urlProps.get('page') || 1;
        if (pageInUrl) {
            setPage(parseInt(pageInUrl, 10));
        }
    }, [urlProps.get('page')]);
    var pageCount = dataframe.getPageCount();
    var start = Math.max(1, Math.min(pageCount - maxLength + 1, page - Math.floor(maxLength / 2)));
    var end = Math.min(pageCount, start + maxLength - 1);
    var renderLink = function (p, value) {
        var _a;
        return (React.createElement("li", { className: gs('page-item', (_a = {}, _a[value ? 'disabled' : 'active'] = p == page, _a)), key: value || p },
            React.createElement(Link, { to: urlProps.mergeLink({ page: p === 1 ? null : p }), className: gs('page-link') }, value || p)));
    };
    var pages = [];
    pages.push(renderLink(1, t('first')));
    pages.push(renderLink(Math.max(1, page - 1), t('previous')));
    for (var i = start; i <= end; i++) {
        pages.push(renderLink(i));
    }
    pages.push(renderLink(Math.min(pageCount, page + 1), t('next')));
    pages.push(renderLink(pageCount, t('last')));
    return React.createElement("ul", __assign({ className: gs('pagination') }, props), pages);
};
var Stats = function (_a) {
    var dataframe = _a.dataframe, props = __rest(_a, ["dataframe"]);
};
var SearchInput = function (_a) {
    var dataframe = _a.dataframe, props = __rest(_a, ["dataframe"]);
    var t = useTranslation()[0];
    var _b = useState(dataframe.getSearch()), value = _b[0], setValue = _b[1];
    var urlProps = useUrlProps(dataframe.getName());
    useEffect(function () {
        if (value) {
            urlProps.push({ search: value });
        }
    }, []);
    useDebouncedEffect(function () {
        dataframe.search(value);
        var valueInUrl = urlProps.get('search');
        if (!value) {
            if (valueInUrl) {
                urlProps.push({ search: null });
            }
        }
        else if (valueInUrl != value) {
            urlProps.push({ search: value });
        }
    }, 350, [value]);
    useEffect(function () {
        setValue(urlProps.get('search'));
    }, [urlProps.get('search')]);
    return (React.createElement("div", { className: gs('input-group') },
        React.createElement("div", { className: gs('input-group-prepend') },
            React.createElement("span", { className: gs('input-group-text', 'text-muted') },
                React.createElement("small", { className: gs('mx-2') },
                    React.createElement(FontAwesomeIcon, { icon: "search" })))),
        React.createElement("input", __assign({ type: "type", value: value || '', className: gs('form-control'), onChange: function (event) { return setValue(event.target.value || null); }, placeholder: t('search') }, props))));
};
var TableLoader = function (_a) {
    var dataframe = _a.dataframe, columns = _a.columns;
    if (dataframe.getData().length > 0 || !dataframe.isLoading()) {
        return null;
    }
    var rows = [];
    var cells = [];
    for (var c = 0; c < columns; c++) {
        cells.push(React.createElement("td", { key: c },
            React.createElement("span", { className: gs('placeholder-content'), style: { width: Math.min(100, (10 % c * 10) + 10) + '%' } })));
    }
    for (var r = 0; r < dataframe.getPerPage(); r++) {
        rows.push(React.createElement("tr", { key: r }, cells));
    }
    return React.createElement(Fragment, null, rows);
};
export { Pager, SearchInput, TableLoader, useDataframe };
